import chroma from "chroma-js"
import { useContext, useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Spinner } from "../../../componentes/Spinner"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import useTestChecker from "../../../hooks/general/useTestChecker"
import AppAPI from "../../../servicos/AppAPI"
import MensagemApp from "../../../servicos/config/MensagemApp"
import validarRedirecionamento from "../../../servicos/config/redirecionamento.jsx"
import {
	normalizarChaveNavegar,
	salvarNavegarPendente,
	lerNavegarPendente,
} from "../../../servicos/config/navegarNotificacao.js"
import { Main } from "./styles"
import { print } from "../../../servicos/Uteis"
import imgSemconexao from "../../../assets/sem-conexao.png"
import logoPadrao from "../../../assets/logo-padrao.svg"
import Refresher from "../../../componentes/uteis/Refresher"
import axios from "axios"

export default function Inicial() {
	const { dados, setDados, erroRequisicao, setErroRequisicao } = useContext(ContextoGeral)

	const [searchParams] = useSearchParams()
	const isTest = useTestChecker(dados.dominio)

	const [dominio, setDominio] = useState('')
	const [rota, setRota] = useState('/home')
	const [param, setParam] = useState('')

	const [configurado, setConfigurado] = useState(false)
	const [preContext, setPreContext] = useState({})

	const [redirect, setRedirect] = useState(false)
	const [invalid, setInvalid] = useState(false)

	const navegar = useNavigate()

	async function inicializar() {
		AppAPI.buscarConfig(dominio).then(config => {
			console.log("aqui");
			console.log(config)
			if (config?.resultado) {
				// Validação de propriedades obrigatórias
				if (!config.dados?.configApp) {
					console.error("configApp não encontrado na resposta")
					setInvalid(true)
					return
				}

				// Logo é opcional: se o backend não enviar, usa fallback local
				// em vez de travar o app com a tela de "sem conexão".
				if (!config.dados?.configApk?.links?.logo) {
					console.warn("configApk.links.logo ausente na resposta — usando logo padrão")
				}

				let json = {}
				let cor = config.dados.configApp.corPrincipal

				// Validação e tratamento de corPrincipal
				if (!cor) {
					console.error("corPrincipal não encontrada, usando cor padrão")
					cor = "#000000" // Cor padrão preta
				}

				try {
					document.documentElement.style.setProperty('--primaria-pura', cor)

					if (chroma(cor).luminance() > 0.9)
						cor = chroma(cor).darken(0.75)
					else if (chroma(cor).luminance() > 0.82 && chroma(cor).luminance() <= 0.9)
						cor = chroma(cor).darken(0.5)
					else if (chroma(cor).luminance() > 0.75 && chroma(cor).luminance() <= 0.82)
						cor = chroma(cor).darken(0.25)

					document.documentElement.style.setProperty('--primaria', cor)
					document.documentElement.style.setProperty('--primaria-bright', chroma(cor).brighten(0.5))
					document.documentElement.style.setProperty('--primaria-brighter', chroma(cor).brighten(1))
					document.documentElement.style.setProperty('--primaria-brightest', chroma(cor).brighten(1.5))
					document.documentElement.style.setProperty('--primaria-dark', chroma(cor).darken(0.5))
					document.documentElement.style.setProperty('--primaria-darker', chroma(cor).darken(1))
					document.documentElement.style.setProperty('--primaria-darkest', chroma(cor).darken(1.5))
					document.documentElement.style.setProperty('--bs-primary', cor)

					config.dados.configApp.corPrincipal = chroma(cor).hex()
				} catch (error) {
					console.error("Erro ao processar cores:", error)
					// Continua com a cor original mesmo se houver erro no processamento
				}

				json.config = config.dados.configApp
				json.config.logo = config.dados?.configApk?.links?.logo ?? logoPadrao
				json.dominio = dominio

				if (config.dados?.configFakeGPS)
					json.configFakeGPS = config.dados.configFakeGPS

				if (config.dados?.configBootClick)
					json.configBootClick = config.dados.configBootClick

				if (config.dados?.otimizacaoBateria)
					json.otimizacaoBateria = config.dados.otimizacaoBateria

				json.modulos = config.dados.modulos

				json.tutoriais = {
					mapa: true,
					cotacoes: true
				}

				json.config.indicar = config.dados.indicaCliente ?? undefined

				if (config.dados?.urlBase) {
					try {
						if (window.AndroidInterface)
							window.AndroidInterface.saveUrlBase(config.dados.urlBase)
					} catch (error) {
						if (isTest) print("Erro ao setar url base")
						console.error('Failed to GET: ' + error)
					}
				}
				if (config.dados?.urlBase) {
					try {
						if (window.AndroidInterface)
							window.AndroidInterface.saveUrlBase(config.dados.urlBase)
					} catch (error) {
						if (isTest) print("Erro ao setar url base")
						console.error('Failed to GET: ' + error)
					}
				}

				if (window.AndroidInterface) {
					if (config.dados?.urlSocketIO) {
						try {
							let urlSocketIO = window.AndroidInterface.getUrlSocketIO()
							if (urlSocketIO != config.dados.urlSocketIO) {
								console.log('Atualizar urlSocketIO')
								window.AndroidInterface.saveUrlSocketIO(config.dados.urlSocketIO)
							}
						} catch (error) {
							if (isTest) print("Erro ao setar url base")
							console.error('Failed to GET: ' + error)
						}
					}

					let versionApp = 0

					try {

						versionApp = window.AndroidInterface.recoverVersion()

						if (versionApp >= 103.00) {
							if (config.dados?.reconnectionDelay) {
								try {
									let reconnectionDelay = window.AndroidInterface.getReconnectionDelay()
									if (reconnectionDelay != config.dados.reconnectionDelay) {
										window.AndroidInterface.saveReconnectionDelay(config.dados.reconnectionDelay)
									}
								} catch (error) {
									if (isTest) print("Erro ao setar url reconnectionDelay")
								}
							}

							if (config.dados?.transports) {
								try {
									let transports = window.AndroidInterface.getTransports()
									if (transports != config.dados.transports)
										window.AndroidInterface.saveTransports(config.dados.transports)
								} catch (error) {
									if (isTest) print("Erro ao setar url transports")
									console.error('Failed to GET: ' + error)
								}
							}
						}
					} catch {
						console.log("Não foi possível recuperar a versão do aplicativo")
					}

					try {
						versionApp = window.AndroidInterface.recoverVersion()
						if (versionApp >= 103.40) {
							if (config.dados?.configFakeGPS) {
								if (window.AndroidInterface) {
									window.AndroidInterface.setConfigGPSFake(config.dados?.configFakeGPS.opcao)
								}
							}
						}
					} catch {
						console.log("Não foi possível recuperar a versão do aplicativo")
					}

				}

				setDados(json)
				setConfigurado(true)
			} else {
				console.error("Configuração inválida: resultado não é true")
				setInvalid(true)
			}
		}).catch(r => {
			console.error("Erro ao buscar configuração:", r)
			setInvalid(true)
		})
	}

	useEffect(() => {
		const raw = searchParams.get('navegar')
		const chave = raw !== null ? normalizarChaveNavegar(raw) : ''
		if (chave !== '') {
			setParam(chave)
			// Sobrevive a um reloadPage() nativo no meio do caminho (ex.: token expirado),
			// já que o campo `navegar` do Android só existe uma vez na 1ª URL carregada.
			salvarNavegarPendente(chave)
		} else {
			const pendente = lerNavegarPendente()
			if (pendente !== '') setParam(pendente)
		}

		const dom = searchParams.get('dominio')
		const params = window.location.href.split('?')[1]
		if (params) {
			const paramArr = params.split('&')
			paramArr.forEach(param => {
				const [key, value] = param.split('=')
				if (key === 'dominio') {
					// setDominio(value == "mototaxionline.srv.br" ? "demonstrativo.logmapp.com.br" : value)
					setDominio(value)
				}
			})
		}

	}, [])

	useEffect(() => {
		if (dominio) inicializar()
	}, [dominio])

	useEffect(() => {
		async function validarToken() {
			if (window?.AndroidInterface) {
				let token = ""

				try {
					token = window.AndroidInterface.recoverToken()
				} catch {
					console.log("não foi possível carregar token")
				}

				if (token != '') {
					AppAPI.validarTokenApp(dominio, token).then(res => {
						if (res?.data)
							res = res.data
						if (res?.resultado) {
							if (res.dados.dadosProf.ativo == 'N' || res.dados.dadosProf.ativo == '')
								setRota('/app/cadastro/pos')
							else if (param === '')
								setRota('/app/home')
							else
								setRota(validarRedirecionamento(param))

							if (res.dados.dadosProf.termoUso) {
								if (window.AndroidInterface) {
									let versionApp = 0

									try {
										versionApp = window.AndroidInterface.recoverVersion()
									} catch {
										console.log("Não foi possível recuperar a versão do aplicativo")
									}

									if (versionApp > 100.39)
										window.AndroidInterface.showTermoApp(res.dados.dadosProf.idProf)
								}
							}

							let json = { ...res.dados.token, ...res.dados.dadosProf }
							// Manter dados de configuração do contexto atual, mas priorizar dados do backend
							json = { ...dados, ...json }

							console.log('Dados do backend (validarTokenApp):', {
								tipoVeiculo: res.dados.dadosProf?.tipoVeiculo,
								siglaTipoVeiculo: res.dados.dadosProf?.siglaTipoVeiculo,
								iconeTipoVeiculo: res.dados.dadosProf?.iconeTipoVeiculo ?? res.dados.token?.iconeTipoVeiculo,
								dadosProfCompleto: res.dados.dadosProf
							});

							setPreContext(json)
							setRedirect(true)
						} else {
							// print(res.msg ?? "Erro ao validar token")
							setRedirect(true)
						}
					}).catch(err => {
						console.error("Erro ao validar token:", err)
						// Verificar se é erro de rede/timeout
						const isNetworkError = err?.message?.includes("Network Error") || 
							err?.code === "ERR_NETWORK" || 
							err?.code === "ECONNABORTED" ||
							err?.message?.toLowerCase().includes("timeout")
						
						if (isNetworkError) {
							// Erro de rede/timeout - mostrar tela de erro
							setInvalid(true)
						} else {
							// Erro de autenticação - redirecionar normalmente
							try {
								window.AndroidInterface.showAndroidVersion(MensagemApp.msgDesconectado)
								window.AndroidInterface.saveToken("")
							} catch (err) {
								//
							} finally {
								setRedirect(true)
							}
						}
					})
				} else setRedirect(true)
			} else {
				if (param !== '') {
					setRota(validarRedirecionamento(param))
				}
				setRedirect(true)
			}
		}

		if (configurado && dominio) validarToken()
	}, [configurado, dominio])

	useEffect(() => {
		(async () => {
			if (Object.keys(preContext).length != 0) {
				delete preContext.config

				setConfigurado(false)
				// Priorizar dados do backend (preContext) sobre dados antigos do contexto (dados)
				// Isso garante que categoria atualizada no backend seja mantida
				const dadosFinais = { ...dados, ...preContext };
				console.log('Merge final de dados:', {
					tipoVeiculo: dadosFinais.tipoVeiculo,
					siglaTipoVeiculo: dadosFinais.siglaTipoVeiculo,
					dadosAntigos: { tipoVeiculo: dados.tipoVeiculo, siglaTipoVeiculo: dados.siglaTipoVeiculo },
					dadosBackend: { tipoVeiculo: preContext.tipoVeiculo, siglaTipoVeiculo: preContext.siglaTipoVeiculo }
				});
				setDados(dadosFinais)
				setRedirect(true)
			}
		})()
	}, [preContext])

	useEffect(() => {
		if (redirect)
			if (rota != '') {
				navegar(rota, { state: { viaNotificacao: param != "" } })
			} else {
				print("falha ao se conectar ao servidor")
				setInvalid(true)
			}
	}, [redirect])

	/**
	 * Utilizado para ter detalhes do erro. 
	 */
	// Limpar erro quando invalid voltar para false (sucesso na conexão)
	useEffect(() => {
		if (!invalid && erroRequisicao) {
			setErroRequisicao(null)
		}
	}, [invalid, erroRequisicao, setErroRequisicao])

	// Limpar erro quando o componente desmontar
	useEffect(() => {
		return () => {
			setErroRequisicao(null)
		}
	}, [setErroRequisicao])

	const formatarDetalhesErro = () => {
		if (!erroRequisicao) return null

		const { requisicao, resposta, mensagem, tipoErro, codigoErro, stack, aux, resultado } = erroRequisicao

		let detalhes = []
		
		// Mensagem principal
		if (mensagem) {
			detalhes.push(`Mensagem: ${mensagem}`)
		}

		// Tipo de erro
		if (tipoErro) {
			detalhes.push(`Tipo: ${tipoErro}`)
		}

		// Código de erro (especialmente útil para erros de conexão e erros da API)
		if (codigoErro) {
			detalhes.push(`Código: ${codigoErro}`)
		}

		// Aux (especialmente para erroDaAPI - ex: 'tokenInvalido')
		if (aux) {
			detalhes.push(`Aux: ${aux}`)
		}

		// Resultado (especialmente para erroDaAPI)
		if (resultado !== null && resultado !== undefined) {
			detalhes.push(`Resultado: ${resultado}`)
		}

		// Detalhes da requisição
		if (requisicao) {
			if (requisicao.method && requisicao.url) {
				detalhes.push(`Requisição: ${requisicao.method} ${requisicao.url}`)
			}
			if (requisicao.endpoint) {
				detalhes.push(`Endpoint: ${requisicao.endpoint}`)
			}
			
			// Informações específicas de conexão (host e porta)
			if (requisicao.hostDestino) {
				detalhes.push(`Host: ${requisicao.hostDestino}`)
			}
			if (requisicao.portaDestino) {
				detalhes.push(`Porta: ${requisicao.portaDestino}`)
			}
			
			if (requisicao.params) {
				detalhes.push(`Parâmetros: ${JSON.stringify(requisicao.params)}`)
			}
			if (requisicao.data) {
				const dataStr = typeof requisicao.data === 'object' 
					? JSON.stringify(requisicao.data) 
					: requisicao.data
				if (dataStr && dataStr !== '{}') {
					detalhes.push(`Dados: ${dataStr}`)
				}
			}
		}

		// Detalhes da resposta
		if (resposta) {
			if (resposta.status) {
				detalhes.push(`Status: ${resposta.status} ${resposta.statusText || ''}`)
			}
			if (resposta.data) {
				const dataStr = typeof resposta.data === 'object' 
					? JSON.stringify(resposta.data, null, 2) 
					: resposta.data
				if (dataStr && dataStr !== '{}') {
					detalhes.push(`Resposta da API: ${dataStr}`)
				}
			}
		}

		// Stack trace (especialmente útil para erros da API)
		if (stack) {
			detalhes.push(`Stack Trace: ${stack}`)
		}

		return detalhes
	}

	return <Main>
		{invalid
			? <div className="flex flex-col items-center justify-center" style={{ height: "100%", padding: "2rem" }}>
				<img
					src={imgSemconexao}
					alt="Você está sem conexão"
					style={{
						width: "100vw",
						marginLeft: "-0.5rem",
						marginBottom: "2rem"
					}}
				/>
				
				{erroRequisicao && (
					<div style={{
						backgroundColor: "rgba(0, 0, 0, 0.7)",
						color: "white",
						padding: "1.5rem",
						borderRadius: "8px",
						maxWidth: "90%",
						marginBottom: "2rem",
						fontSize: "0.9rem",
						overflow: "auto",
						maxHeight: "40vh"
					}}>
						<div style={{ fontWeight: "bold", marginBottom: "1rem", fontSize: "1.1rem" }}>
							Detalhes do Erro:
						</div>
						{formatarDetalhesErro()?.map((detalhe, index) => (
							<div key={index} style={{ marginBottom: "0.5rem", wordBreak: "break-word" }}>
								{detalhe}
							</div>
						))}
					</div>
				)}

				<div className="absolute w-full flex justify-center" style={{ bottom: "3rem" }}>
					<Refresher onClick={() => {
						// Limpar erro antes de tentar novamente
						setErroRequisicao(null)
						setInvalid(false)
						if (window.AndroidInterface)
							window.AndroidInterface.reloadPage()
						else
							window.location.reload()
					}} />
				</div>
			</div>
			: <Spinner />}
	</Main>
}